import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./addressGetActions";

function* addressGet(action) {
  try {
    let { data } = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      `addresses/${action.id}`
    );

    const { address, relationships } = data;

    const references = relationships.references
      .filter((reference) => reference.sharedObjectId === action.id)
      .map((reference) => reference.referenceCollection);

    yield put(actions.requestSuccess({ ...address, references }, action.id));

    if (action.resolve) {
      yield call(action.resolve);
    }
  } catch (error) {
    yield put(actions.requestFailure(error, action.id));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.ADDRESS_GET_REQUEST, addressGet);
}

export default saga;
